var _a;
import { routeMenu } from '@lxunit/app-l2c-crm';
export var TopMenuPath;
(function (TopMenuPath) {
    TopMenuPath["worktable"] = "worktable";
    TopMenuPath["systemTask"] = "systemTask";
    TopMenuPath["noviceTask"] = "noviceTask";
    TopMenuPath["mailbox"] = "mailbox";
    TopMenuPath["wa"] = "wa";
    TopMenuPath["wmData"] = "wmData";
    TopMenuPath["intelliMarketing"] = "intelliMarketing";
    TopMenuPath["unitable_crm"] = "/unitable-crm";
    TopMenuPath["unitable_crm_2"] = "/unitable-crm/sell-order/list";
    TopMenuPath["site"] = "site";
    TopMenuPath["rbac"] = "rbac";
    TopMenuPath["coop"] = "coop";
    TopMenuPath["enterpriseSetting"] = "enterpriseSetting";
    TopMenuPath["notificationCenter"] = "notificationCenter";
    TopMenuPath["aiStaff"] = "aiStaff";
    TopMenuPath["aiTeam"] = "aiTeam";
    TopMenuPath["personal"] = "personal";
    TopMenuPath["customerSettingLh"] = "setting";
    TopMenuPath["backgroundCheck"] = "backgroundCheck";
})(TopMenuPath || (TopMenuPath = {}));
export const speUrl = [TopMenuPath.mailbox, TopMenuPath.worktable, TopMenuPath.notificationCenter, TopMenuPath.aiTeam];
export const USER_DEFINED_MENU_LABELS = {
    WA: true,
    CUSTOMER_PROSPECTING: true,
    CUSTOMER_EXLOIT: true,
    CUSTOMER_MANAGE: true,
    CUSTOMER_PROMISE: true,
    WEBSITE_ADMIN: true,
};
export const WAIMAO_PRODUCT_VERSIONS = {
    FREE: 'FREE',
    FASTMAIL: 'FASTMAIL',
    WEBSITE: 'WEBSITE',
    FASTMAIL_AND_WEBSITE: 'FASTMAIL_AND_WEBSITE',
    FASTMAIL_EXPIRED: 'FASTMAIL_EXPIRED',
};
export const UniHeaderMenu = {
    uniTableLead: {
        path: routeMenu.lead.path,
        uniTableIdFlag: 'LEADS',
    },
    uniTableLeadPublicSea: {
        path: routeMenu.publicLeadList.path,
        uniTableIdFlag: 'LEAD_PUBLIC_SEA',
    },
    uniTableCustomer: {
        path: routeMenu.custom.path,
        uniTableIdFlag: 'CUSTOMER',
    },
    uniTableCustomerPublicSea: {
        path: routeMenu.publicCustom.path,
        uniTableIdFlag: 'CUSTOMER_PUBLIC_SEA',
    },
    uniTableBusiness: {
        path: routeMenu.business.path,
        uniTableIdFlag: 'CUSTOMER_BUSINESS',
    },
    uniTableCustomerLabel: {
        path: routeMenu.customLabel.path,
        uniTableIdFlag: 'CUSTOMER_CUSTOMER_LABEL',
    },
    uniTableQuotation: {
        path: routeMenu.quotation.path,
        uniTableIdFlag: 'QUOTATION',
    },
    uniTableSellOrder: {
        path: routeMenu.sellOrder.path,
        uniTableIdFlag: 'SALES_ORDER',
    },
    uniTablePaymentReceipt: {
        path: routeMenu.paymentReceipt.path,
        uniTableIdFlag: 'PAYMENT_RECEIPT',
    },
    uniTableContacts: {
        path: routeMenu.contacts.path,
        uniTableIdFlag: 'CONTACT',
    },
    uniTableLocalCommodity: {
        path: routeMenu.localProduct.path,
        uniTableIdFlag: 'PRODUCT',
    },
    uniTablePlatformCommodity: {
        path: routeMenu.platformProduct.path,
        uniTableIdFlag: 'PLATFORM_PRODUCT',
    },
    uniTableSupplier: {
        path: routeMenu.supplierManagement.path,
        uniTableIdFlag: 'SUPPLIER',
    },
    uniRecommendCustomer: {
        path: (_a = routeMenu.recommendList) === null || _a === void 0 ? void 0 : _a.path,
        uniTableIdFlag: 'RECOMMEND_CUSTOMER',
    },
};
